import { helpers } from './base'

export const CancellationPolicyModal = helpers.defineMultiStyleConfig({
  baseStyle: {
    cancellationFeesAndPoliciesContainer: {
      h1: {
        marginTop: 2,
        fontSize: 'lg',
        color: 'brand.coolgrey10',
      },
    },
    policyLink: {
      color: 'brand.tealDarker',
      fontSize: 'lg',
    },
  },
})
